import { render, staticRenderFns } from "./WikiSearchModal.vue?vue&type=template&id=74e3fb4e"
import script from "./WikiSearchModal.vue?vue&type=script&lang=js"
export * from "./WikiSearchModal.vue?vue&type=script&lang=js"
import style0 from "./WikiSearchModal.vue?vue&type=style&index=0&id=74e3fb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports